export const courseName = {
  pm: "PM",
  mkt: "마케터",
};

export const courseRound = {
  pm: 2,
  mkt: 1,
};

export const courseOnlineClass = {
  pm: "웹개발 기초 강의",
  mkt: "SQL 기초 강의",
};

export const coursePrice = (isEarlyBirdEnd) => {
  return {
    pm: `${isEarlyBirdEnd ? "330" : "260"}만 원`,
    mkt: "200만 원",
  };
};

export const courseInstallmentPrice = (isEarlyBirdEnd) => {
  return {
    pm: `월 ${isEarlyBirdEnd ? "27" : "21"}만 원${isEarlyBirdEnd ? "대" : ""}`,
    mkt: "월 17만 원",
  };
};

export const apply2PageAllowFunnels = [
  "1차서류완료",
  "2차지원리마인드-3H",
  "2차지원리마인드-24H",
];

export const appliedPageAllowFunnels = ["2차서류완료"];
export const reservePageAllowFunnels = [
  "서류합격",
  "서류합격후-1H",
  "서류합격후-3H",
  "면접조율리마인드-24H",
  "면접조율리마인드-72H",
  "면접취소",
];

export const reservedPageAllowFunnels = ["면접예정"];

export const paymentPageAllowedFunnels = [
  "면접합격",
  "면접합격-30M",
  "가상계좌안내",
  "결제안내리마인드-24H",
  "결제안내리마인드-72H",
  "결제완료",
];
